/**
 * Fingerprint of the set of row ids a projected list holds. IDENTICAL to functions/src/forms/dataSources/idsHash.ts (cyrb53 over the ids
 * sorted by UTF-16 code unit, joined with NUL); both are pinned by the same golden vector. The phone recomputes it over the list it built
 * by merging a delta and compares with the server's: equal = its list is the server's, unequal = fetch the full list. It guards
 * against accident (a hard delete leaves no updateTime to see, a missed change), not an attacker.
 */
export function idsHash(ids: readonly string[]): string {
  const text = [...ids].sort().join('\u0000');
  let h1 = 0xdeadbeef;
  let h2 = 0x41c6ce57;
  for (let i = 0; i < text.length; i += 1) {
    const ch = text.charCodeAt(i);
    h1 = Math.imul(h1 ^ ch, 2654435761);
    h2 = Math.imul(h2 ^ ch, 1597334677);
  }
  h1 = Math.imul(h1 ^ (h1 >>> 16), 2246822507) ^ Math.imul(h2 ^ (h2 >>> 13), 3266489909);
  h2 = Math.imul(h2 ^ (h2 >>> 16), 2246822507) ^ Math.imul(h1 ^ (h1 >>> 13), 3266489909);
  return (4294967296 * (2097151 & h2) + (h1 >>> 0)).toString(16).padStart(14, '0');
}
